export default __webpack_public_path__ + "static/media/construction-worker.b5f276ec.png";